import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { AdminService } from "../services/admin-service";
import { NotifyService } from "../services/notify-service";
import { SearchService } from "../services/search-service";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";
import { ContactService } from "../services/contact-service";
import { EventService } from "../services/event-service";
import { AclService } from "../services/acl-service";
import * as angular from "angular";

export function RLTypeAheadInput() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/type-ahead-input.html"),
        controller: RLTypeAheadInputController,
        controllerAs: "taVM",
        bindToController: true,
        scope: {
            searchCharTypeID: "=searchCharTypeId",
            templateID: "=templateId",
            party: "=party",
            entityID: "=entityId",
            partyContact: "=?",
            contactIndex: "=?",
            partyGroupContacts: "=?",
            contactTemplates: "=?"
        }
    };

    return directive;
}


export class RLTypeAheadInputController {
    static $inject = ["$scope", "$q", "$window", "$filter", "$interval", "adminService", "notifyService", 'searchService', 'entityConfigService', 'entityService', 'contactService', 'eventService', "aclService"];

    templateURL: string;
    searchResults: any[];
    searchCharTypeID: number;
    templateID: number;
    party: Models.IParty;
    entityID: string;
    filterTemplate: string;
    allowMultiples: boolean;
    allParties: Models.IContactParty[];
    selectedContacts: Models.IContactSearchModel[];
    resultsShown: boolean;
    typedName: string;
    searchGroups: Models.ISearchGroup[];
    currentIndex: number;

    filteredContactTemplates: Models.ICharacteristicTemplate[];
    contactTemplates: Models.ICharacteristicTemplate[];
    charTypeID: number;
    recID: number;
    searchContactModalOpen: boolean;
    associateContactModalOpen: boolean;
    searchContactPartyID: number;
    searchContactModalTitle: string;
    associateContactModalTitle: string;
    createContactCharDataCollection: Models.ICharDataCollection;
    createMode: boolean;
    visibility: number;
    showRequiredOnly: boolean;

    editContactModalOpen: boolean;
    editContactCharDataCollection: Models.ICharDataCollection;
    editContactModalTitle: string;
    updateMode: string;

    //Progress
    jobTitle: string;
    progressJobID: string;
    public progressModalOpen: boolean;
    progressStatus: string;
    progressComplete: number;
    progressFailed: number;
    progressFailedPercentage: number;
    progressTotal: number;
    progressPercentage: number;
    progressIntervalPromise: ng.IPromise<any>;
    progressOnComplete: () => any;

    //Drag and Drop
    sortableOptions: any;
    contactIndex: number;
    newContact: Models.IContactSearchModel;
    removeContactModalOpen: boolean;
    deleteContactText: string;
    parentCharTypeName: string;
    removeContactRecordID: number;
    partyGroupContacts: Array<Models.IEntityRelationshipPair>;

    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private $window: ng.IWindowService,
        private $filter: ng.IFilterService,
        public $interval: ng.IIntervalService,
        public adminService: AdminService,
        private notifyService: NotifyService,
        private searchService: SearchService,
        private entityConfigService: EntityConfigService,
        private entityService: EntityService,
        private contactService: ContactService,
        private eventService: EventService,
        private aclService: AclService) {

        this.allowMultiples = false;
        this.selectedContacts = [];
        this.resultsShown = false;
        this.searchGroups = [];
        this.allParties = [];

        this.filteredContactTemplates = [];
        this.searchContactModalOpen = false;
        this.associateContactModalOpen = false;
        this.createMode = false;
        this.visibility = 1;

        this.showRequiredOnly = true;

        this.updateMode = "system";

        //Progress
        this.progressJobID = "";
        this.progressModalOpen = false;
        this.progressStatus = "";
        this.progressComplete = 0;
        this.progressFailed = 0;
        this.progressTotal = 0;
        this.progressPercentage = 0;
        this.progressFailedPercentage = 0;
        this.progressIntervalPromise = null;
        this.progressOnComplete = null;
        this.createContactCharDataCollection = undefined;
        this.removeContactModalOpen = false;
        this.deleteContactText = "";
        this.parentCharTypeName = "";

        //Drag and Drop
        this.sortableOptions = {
            accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
                var correctPartyGroup = sourceItemHandleScope.itemScope.sortableScope.$parent.$parent.partyGroup.$$hashKey === destSortableScope.$parent.$parent.partyGroup.$$hashKey;
                var isAtTheEndOfMulti = false;

                if (destItemScope != null) {
                    isAtTheEndOfMulti = destItemScope.contact.contactID == null;
                }

                return correctPartyGroup && !isAtTheEndOfMulti;
            },
            orderChanged: (event) => {
                this.UpdateContactsOrder(event);
            }
        };

        $scope.$watchCollection(() => [this.searchCharTypeID, this.templateID, this.party, this.entityID],
            (newValue, oldValue) => {
                if (this.searchCharTypeID != null && this.templateID != null && this.party != null && this.entityID != null) {
                    this.SetValues();
                }
            });
    }

    FormatValue(model) {
        if (model != null) {
            return model.name;
        }
    }

    SetValues() {
        this.charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;
        this.recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;

        this.contactService.getPartyTemplates(this.charTypeID, this.templateID, this.party.partyID)
            .then((templateResult) => {
                this.aclService.loadDataAcls().then((aclResult) => {
                    //filter the list of templates allowed to be created by those that can be added to this party
                    this.filteredContactTemplates = _.filter(this.contactTemplates, (t) => {
                        return _.any(templateResult, (pt) => {
                            var partyTemplate = Utils.IdBuilder.splitTemplateID(pt);
                            return partyTemplate.templateID == t.templateID && Utils.AclUtil.hasCreateAccess(aclResult, Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.user, t.templateGroupID, t.templateID));
                        })
                    });
                });
            })

        switch (this.searchCharTypeID) {
            case Consts.CharTypeIDs.user:
                this.templateURL = "contactTemplate.html";

                if (this.party.multipleIndicator == 1) {
                    this.allowMultiples = true;
                }
                this.selectedContacts = [];
                var sortedList = _.sortBy(this.partyGroupContacts, c => c.relationship.sequenceNumber);

                if (sortedList.length > 0) {
                    _.forEach(sortedList, (c) => {
                        if (c.record != undefined) {
                            this.selectedContacts.push({
                                contactID: c.record.recordID, name: this.GetCharValue(c.charDataCollection, "entity_title"),
                                parentCharTypeID: c.relationship.parentCharTypeID,
                                charDataCollection: c.charDataCollection,
                                sequenceNumber: c.relationship.sequenceNumber
                            });
                        }
                    });
                }
                else if (!this.allowMultiples) {
                    this.selectedContacts.push({ contactID: null, name: '', parentCharTypeID: null, charDataCollection: null, sequenceNumber: -1 });
                }

                if (this.allowMultiples) {
                    //The sequence number is large here so that it is sorted to the end of the array
                    this.selectedContacts.push({ contactID: null, name: '', parentCharTypeID: null, charDataCollection: null, sequenceNumber: 1000 });
                }
                break;
            default:
                this.templateURL = "genericTemplate.html";
                break;
        }
    }


    private aclResults: _.Dictionary<boolean> = {};

    GetCharValue(collection: Models.ICharDataCollection, tagLabel: string) {

        if (tagLabel = "entity_title") {
            var hasRead = this.HasRead(collection);
            if (!hasRead) {
                return `${collection.templateMetaData.template.templateName} #${Utils.IdBuilder.splitEntityID(collection.entityID).recID}`;
            }
        }


        var charDatas = collection.charDatas[tagLabel];
        if (charDatas != null && charDatas.length > 0) {
            return charDatas[0].value || "";
        }
        return "";
    }

    HasRead(collection: Models.ICharDataCollection) {
        if (collection == null) {
            return false;
        }
        if (this.aclResults[collection.templateMetaData.template.acl] == null) {
            this.aclResults[collection.templateMetaData.template.acl] = Utils.AclUtil.hasReadAccess(this.aclService.acls, collection.templateMetaData.template.acl);
        }
        return this.aclResults[collection.templateMetaData.template.acl];
    }

    Search(keyword, index) {

        this.typedName = keyword;
        this.currentIndex = index;

        var req: Models.ISearchRequest = {
            k: keyword || "",			                // keywords
            t: "",	                                    // selected	template
            s: "",		                                // selected	status
            p: 1,				                        // current page
            r: 20,						                // row count
            sf: "",			                            // sort Field
            sd: 0,			                            // sort direction 0 - ascending, 1 - descending
            ct: this.charTypeID,                        // charTypeID
            pid: this.party.partyID,                          // partyID
            tid: this.templateID                        // parent templateID
        };

        //Get results based on inputed characters
        return this.contactService.searchTypeAhead(req)
            .then((results) => {
                this.resultsShown = true;
                return results.resultDocs;
            });
    }

    RefreshTemplates(): ng.IPromise<any> {
        this.notifyService.startProgress();
        return this.entityConfigService.getCharacteristicTemplates(Consts.CharTypeIDs.user)
            .then((result) => {
                this.contactTemplates = result;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SearchForContact(contact: Models.IContactSearchModel, index: number) {
        this.createMode = false;

        this.currentIndex = index;

        this.searchContactModalOpen = true;
        this.searchContactPartyID = this.party.partyID;
        this.searchContactModalTitle = "Add contact to " + this.party.partyName + " Party";
    }

    //Open up the new contact modal
    NewContact(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent, contact: Models.IContactSearchModel, index?: number) {
        this.notifyService.startProgress();

        if (!_.isNull(index)) {
            this.currentIndex = index;
        }

        this.createContactCharDataCollection = undefined;
        this.searchContactModalOpen = true;
        this.searchContactPartyID = this.party.partyID;
        if (this.typedName != undefined) {
            this.searchContactModalTitle = "Create " + template.templateName + ": " + this.typedName;
        }
        else {
            this.searchContactModalTitle = "Create " + template.templateName;
        }
        $event.preventDefault();
        var divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
        var charTypeID = Consts.CharTypeIDs.user;
        var templateID = Utils.IdBuilder.buildTemplateID(divID, charTypeID, template.templateID);

        this.entityService.getEmptyEntityCharData(templateID)
            .then((result) => {
                if (this.typedName != '') {
                    var titleCharID = _.find(result.templateMetaData.characteristicMetaDatas, c => c.tagLabel == "entity_title");
                    result.charDatas["entity_title"].push({ charID: titleCharID.characteristicID, recCharID: 0, value: this.typedName, valueID: null });
                }
                this.createContactCharDataCollection = result;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
        this.createMode = true;
    }

    //Create the new contact and associate it to the party
    CreateContact(isValid: boolean, andAssociate: boolean) {
        if (isValid) {
            var charDatas = this.createContactCharDataCollection.charDatas;
            var templateID = this.createContactCharDataCollection.templateMetaData.templateID;

            this.notifyService.startProgress();

            var selectedContact = this.selectedContacts[this.selectedContacts.length - 1];
            var oldContact = this.FindOldContactInCollection(this.currentIndex);

            if (oldContact != null && oldContact.contactID != null) {
                //Remove the old contact
                this.RemoveOldContact(oldContact.contactID);
            }
            else if (selectedContact != null && selectedContact.contactID == null) {
                //Remove the dummy object only
                this.RemoveFromCollection(selectedContact, null);
            }

            this.contactService.createAssociatedContact(templateID, charDatas)
                .then((result) => {
                    this.newContact = undefined;
                    if (!result.success) {
                        this.notifyService.notifyError("Error creating Contact");
                    }
                    var newContactEntityID = Utils.IdBuilder.splitEntityID(result.entityID);
                    var newContactRecID = newContactEntityID.recID;
                    var contact = newContactRecID + "|" + this.typedName;
                    var contactName = "";
                    if (_.any(this.createContactCharDataCollection.charDatas["first_name"])) {
                        var firstNameCharDatas = this.createContactCharDataCollection.charDatas["first_name"];
                        var lastNameCharDatas = this.createContactCharDataCollection.charDatas["last_name"]
                        if (!_.isEmpty(firstNameCharDatas[0].value)) {
                            contactName = firstNameCharDatas[0].value;
                        }

                        if (!_.isEmpty(lastNameCharDatas[0].value)) {
                            contactName = contactName + ' ' + lastNameCharDatas[0].value;
                        }
                    }
                    else {
                        var contactNameCharDatas = this.createContactCharDataCollection.charDatas["entity_title"];
                        contactName = contactNameCharDatas[0].value;
                    }

                    this.newContact = {
                        contactID: newContactRecID,
                        name: contactName,
                        charDataCollection: this.createContactCharDataCollection,
                        parentCharTypeID: null,
                        sequenceNumber: null
                    };
                    return this.AssociateContactToParty(contact, true);
                })
                .finally(() => {
                    //this.SetValues();
                    if (andAssociate) {
                        this.AssociateContactToContact();
                    }
                    this.createContactCharDataCollection = undefined;
                    this.notifyService.endProgress();
                });
        } else {
            this.notifyService.broadcastDone();
        }
    }

    AssociateContactFromQuickSearch(contact: string) {
        this.AssociateContactToParty(contact, false);
    }

    //Associate to contact to the party
    AssociateContactToParty(contact: string, isNew: boolean) {
        this.notifyService.startProgress();
        //var partyID = this.searchContactPartyID;
        var splits = contact.split("|");
        var contactID = _.parseInt(splits[0]);
        var contactName = splits[1];
        var selectedContact = this.selectedContacts[this.selectedContacts.length - 1];

        //If there is only one item in the collection and the party does not allow multiples, then remove the old contact
        if (this.selectedContacts.length == 1 && this.allowMultiples == false) {
            this.RemoveOldContact(selectedContact.contactID);
        }
        else if (isNew && selectedContact != null && selectedContact.contactID == null) {
            //A brand new item is being associated, so remove the blank item added to the collection
            this.RemoveFromCollection(selectedContact, null);
        }
        else if (!isNew) {
            //Remove the old record and add the new
            var oldContact = this.FindOldContactInCollection(this.currentIndex);

            if (oldContact != null && oldContact.contactID != contactID) {
                this.RemoveOldContact(oldContact.contactID);
            }
        }

        this.DoAssociation(contactID, contactName, true);
    }

    //Take the type ahead selected contact and associates it to the party
    SelectTypeAheadContact(item) {
        //Persist the data
        this.notifyService.startProgress();

        var selectedContact = this.selectedContacts[this.selectedContacts.length - 1];
        var oldContact = this.FindOldContactInCollection(this.currentIndex);

        if (oldContact != null && oldContact.contactID != item.contactID) {
            //Remove the old contact
            this.RemoveOldContact(oldContact.contactID);
        }
        else if (selectedContact != null && selectedContact.contactID == null) {
            //Remove the dummy object only
            this.RemoveFromCollection(selectedContact, null);
        }

        this.DoAssociation(item.contactID, item.name, false);
    }

    //Remove the old associated contact to the party
    RemoveOldContact(contactID: number) {
        this.notifyService.startProgress();
        this.contactService.removeContactFromEntity(this.charTypeID, this.recID, this.party.partyID, contactID)
            .then((result) => {
                if (result) {
                    this.eventService.call(Consts.Events.RefreshTables);
                    this.notifyService.endProgress();
                    this.RemoveFromCollection(null, contactID);
                }
                else {
                    this.notifyService.notifyError("Error removing old contact");
                }
                this.removeContactRecordID = 0;
                this.deleteContactText = "";
                this.parentCharTypeName = "";
                this.removeContactModalOpen = false;
            });
    }

    DoAssociation(contactID: number, contactName: string, closeSearchModal: boolean) {

        var sequenceNumber: number = 0;
        if (this.partyGroupContacts.length > 0) {
            //var sortedList = _.sortBy(this.partyGroupContacts, c => c.relationship.sequenceNumber);
            sequenceNumber = this.partyGroupContacts.length;
        }

        return this.contactService.associateContactToEntity(this.charTypeID, this.recID, this.party.partyID, contactID, sequenceNumber)
            .then((result) => {
                if (result) {
                    this.notifyService.notifySuccess("Contact Added");
                } else {
                    this.notifyService.notifyError("Error adding contact");
                }
            })
            .then(() => {
                if (closeSearchModal && this.searchContactModalOpen) {
                    this.searchContactModalOpen = false;
                }
                this.RefreshValidation();
            })
            .finally(() => {
                this.resultsShown = false;
                this.UpdatePartyGroupContacts();
                this.notifyService.endProgress();
            });

        //How many contacts do we currently have?  We want to add this new one at the end of the list
        //this.contactService.getContactsForEntityByParty(this.entityID, this.party.partyID)
        //	.then((results) => {

        //		var sequenceNumber = 0;

        //		if (results.contacts) {
        //			sequenceNumber = results.contacts.length;
        //		}

        //		return this.contactService.associateContactToEntity(this.charTypeID, this.recID, this.party.partyID, contactID, sequenceNumber)
        //			.then((result) => {
        //				if (result) {
        //					this.notifyService.notifySuccess("Contact Added");
        //				} else {
        //					this.notifyService.notifyError("Error adding contact");
        //				}
        //			})
        //			.then(() => {
        //				if (closeSearchModal && this.searchContactModalOpen) {
        //					this.searchContactModalOpen = false;
        //				}
        //				this.RefreshValidation();
        //			})
        //			.finally(() => {
        //				this.resultsShown = false;
        //				this.SetValues();
        //				this.notifyService.endProgress();
        //			});
        //	});
    }

    private UpdatePartyGroupContacts() {
        this.contactService.getContactsForEntityByParty(this.entityID, this.party.partyID)
            .then((result) => {
                this.selectedContacts = [];
                if (result != null) {
                    //Does the party allow multiples?
                    if (result.party.multipleIndicator == 1) {
                        this.allowMultiples = true;
                    }

                    //Bind the data
                    if (result.contacts.length > 0) {
                        var sortedList = _.sortBy(result.contacts, c => c.relationship.sequenceNumber);
                        _.forEach(sortedList, (c) => {
                            if (c.record != undefined) {
                                this.selectedContacts.push({ contactID: c.record.recordID, name: this.GetCharValue(c.charDataCollection, "entity_title"), parentCharTypeID: c.relationship.parentCharTypeID, charDataCollection: c.charDataCollection, sequenceNumber: c.relationship.sequenceNumber });
                            }
                        });
                    }
                    else if (!this.allowMultiples) {
                        this.selectedContacts.push({ contactID: null, name: '', parentCharTypeID: null, charDataCollection: null, sequenceNumber: -1 });
                    }

                    if (this.allowMultiples) {
                        //The sequence number is large here so that it is sorted to the end of the array
                        this.selectedContacts.push({ contactID: null, name: '', parentCharTypeID: null, charDataCollection: null, sequenceNumber: 1000 });
                    }
                }
            });
    }

    AddToCollection() {
        //The sequence number is large here so that it is sorted to the end of the array
        var contact = { contactID: null, name: '', parentCharTypeID: null, charDataCollection: null, sequenceNumber: 1000 }
        this.selectedContacts.push(contact);
    }

    RemoveFromCollection(selectedContact: Models.IContactSearchModel, contactID: number) {
        var doRemoval = false;

        if (selectedContact == null) {
            //Find the instance of the object in the collection based on the ID
            var results = _.filter(this.selectedContacts, (contact: Models.IContactSearchModel) => contact.contactID == contactID);

            if (results.length > 0) {
                selectedContact = results[0];
                doRemoval = true;
            }
        }
        else {
            doRemoval = true;
        }

        if (doRemoval) {
            var index = this.selectedContacts.indexOf(selectedContact);
            this.selectedContacts.splice(index, 1);
        }
    }

    FindOldContactInCollection(index: number) {
        return this.selectedContacts[index];
    }

    //Add additional associations (parent, child, sibling) to the new contact
    AssociateContactToContact() {
        this.searchContactModalOpen = false;
        this.associateContactModalOpen = true;
        this.associateContactModalTitle = "Optional - ";
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    OverwriteContacts(contact: Models.IContactSearchModel, partyID: number, partyName: string) {
        if (this.$window.confirm("Are you sure you want to overwrite the contact(s) in " + partyName + " to " + contact.name + " for associated records?")) {
            this.notifyService.startProgress();
            var recordID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
            var contactID = contact.contactID;
            var charTypeID = contact.parentCharTypeID;

            this.contactService.overwriteContacts(this.entityID, contactID, partyID)
                .then((result) => {
                    this.notifyService.endProgress();
                    var jobID = result.jobID;
                    this.jobTitle = result.jobTitle;
                    this.ShowProgress(jobID, () => {
                    });
                },
                () => {
                    this.notifyService.notifyError("Error overwriting party contacts");
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    ResyncContact(contact: Models.IContactSearchModel) {
        if (this.$window.confirm("Are you sure you want to resync this contact profile from system values?")) {
            this.notifyService.startProgress();
            var recordID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
            this.contactService.resyncContact(contact.parentCharTypeID, recordID, contact.contactID)
                .then(() => {
                    this.notifyService.notifySuccess("Contact Profile Resynced");
                    //this.SetValues();
                    this.UpdatePartyGroupContacts();
                },
                () => {
                    this.notifyService.notifyError("Error resyncing contact");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    EditContact(contact: Models.IContactSearchModel) {
        this.editContactCharDataCollection = _.cloneDeep(contact.charDataCollection);
        this.editContactModalTitle = "Edit " + contact.name;
        this.editContactModalOpen = true;
    }

    ShowRemoveContact(contactID: number, contactName: string) {
        this.removeContactRecordID = contactID;
        this.deleteContactText = "";
        this.parentCharTypeName = Utils.CharTypeUtil.GetCharTypeName(this.charTypeID);
        this.deleteContactText = contactName + " will be removed from any Tables on this " + this.parentCharTypeName + ". <br/> Are you sure you want to remove this association?"
        this.removeContactModalOpen = true;
    }

    RemoveContact() {
        this.RemoveOldContact(this.removeContactRecordID);
        //this.SetValues();			
        this.RefreshValidation();
        this.$scope.$broadcast(Consts.Events.NotifyDone);
    }

    SaveContact(isValid: boolean) {
        if (isValid) {
            var contactID = Utils.IdBuilder.splitEntityID(this.editContactCharDataCollection.entityID).recID;
            var charDatas = this.editContactCharDataCollection.charDatas;
            var updateProfile = !(this.updateMode.toLowerCase() == "contact");

            this.notifyService.startProgress();

            this.contactService.updateContactPartyCharacteristics(this.charTypeID, this.recID, contactID, charDatas, updateProfile)
                .then(() => {
                    var selectedContact = _.find(this.selectedContacts, s => s.contactID == contactID);
                    selectedContact.charDataCollection.charDatas = charDatas;
                    this.notifyService.notifySuccess("Contact updated");
                }, () => {
                    this.notifyService.notifyError("Error updating contact");
                })
                .then(() => {
                    this.editContactModalOpen = false;
                    this.RefreshValidation();
                }, angular.noop)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    //Progress Functions
    ShowProgress(jobID: string, onComplete: () => any) {
        this.ResetProgress();

        this.progressJobID = jobID;
        this.progressOnComplete = onComplete;

        this.notifyService.startProgress();
        this.progressIntervalPromise = this.$interval(() => this.UpdateProgress(), 2000);
        this.UpdateProgress();
        this.progressModalOpen = true;
    }

    UpdateProgress() {
        this.adminService.getJobState(this.progressJobID)
            .then((result) => {
                this.progressComplete = result.completed;
                this.progressFailed = result.failed;
                this.progressStatus = result.status;
                this.progressTotal = result.total;
                this.progressPercentage = (this.progressComplete / this.progressTotal) * 100;
                this.progressFailedPercentage = (this.progressFailed / this.progressTotal) * 100;


                if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
                    this.$interval.cancel(this.progressIntervalPromise);
                    if (this.progressOnComplete != null) {
                        this.$q.when(this.progressOnComplete())
                            .then(() => {
                                this.notifyService.endProgress();
                            });
                    } else {
                        this.notifyService.endProgress();
                    }
                }
            });
    }

    CancelJob() {
        this.adminService.cancelJob(this.progressJobID)
            .then((res) => {
            });
    }

    ResetProgress() {
        this.progressJobID = "";
        this.progressModalOpen = false;
        this.progressStatus = "";
        this.progressComplete = 0;
        this.progressTotal = 0;
        this.progressPercentage = 0;
        if (this.progressIntervalPromise != null) {
            this.$interval.cancel(this.progressIntervalPromise);
            this.progressIntervalPromise = null;
        }
    }

    //Drag and drop
    UpdateContactsOrder(event) {
        //This is the updated list of contacts
        var newOrderList: Models.IContactSearchModel[] = event.dest.sortableScope.modelValue;

        //Remove any blank/default rows
        var cleanList = newOrderList.filter(c => c.contactID != null);
        var contactsRecIDAndSequence: { [recID: number]: number } = {};
        var newSequenceNumber = -1;

        if (event.dest.index == 0) {
            //If we're at the beginning of the list, get the next sequence number and / 2
            newSequenceNumber = _.ceil(cleanList[event.dest.index + 1].sequenceNumber / 2);
        }
        else if (event.dest.index + 1 == cleanList.length) {
            //If we're at the end of the list, get the previous sequence number and add 4096
            newSequenceNumber = cleanList[event.dest.index - 1].sequenceNumber + 4096;
        }
        else {
            //Get the destination index + 1 so we can calculate the new sequence number
            var itemBeforeIndex = cleanList[event.dest.index - 1].sequenceNumber;
            var itemAfterIndex = cleanList[event.dest.index + 1].sequenceNumber;
            newSequenceNumber = _.ceil((itemBeforeIndex + itemAfterIndex) / 2);
        }

        var contactID = cleanList[event.dest.index].contactID;
        _.first(_.filter(this.selectedContacts, c => c.contactID == contactID)).sequenceNumber = newSequenceNumber;
        contactsRecIDAndSequence[contactID] = newSequenceNumber;
        this.entityService.setRecordOrder(this.entityID, Consts.CharTypeIDs.user, contactsRecIDAndSequence);
    };
}
